
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.647 7.67a1.46 1.46 0 01.234.002c.83.092.596.477 1.389.892.795.415.454.604.31 1.18-.144.579.445 1.814.989 2.229.415.318.199 1.704.072 2.347A7.144 7.144 0 01.842 8c0-.037.003-.072.005-.11.216-.096.502-.198.8-.22zM8 .845c.927 0 1.811.176 2.621.497-.01.04-.03.116-.067.315-.13.678.236.96.522.678.288-.28.8-.03.526.34-.273.368-.817-.22-.544.518.274.924-.732.198-.84.998-.086.651.624.639 1.05.388.419-.249.38-.621 1.17-.683.7-.055 1.87 1.036 1.445 1.383-.313.256-.611.142-.88-.07-.094-.076-.15-.39-.43-.523-.417-.202-1.033.23-1.689.509-.655.276-1.796 1.108-1.214 2.621.35.914.765 1.227 1.443 1.116.33-.055.885-.375 1.237-.117.619.452 1.138 1.545.838 2.4-.276.783-.043 1.344.111 1.597a7.134 7.134 0 01-5.301 2.346 7.136 7.136 0 01-1.926-.264c.39-.342 1.444-1.319 1.62-2.136.134-.611.715.092 1.22-1.33.807-2.285-.671-1.055-1.252-1.793-.554-1.173-.92-.587-1.441-1.09-.522-.508-1.18-.46-1.715-.244-.534.218-.802-.107-.916-.497-.18-.602-.713-.75-1.424-.753-.475 0 .196-.832.425-1.046.323-.3 1.06-.37 1.185-.102.127.268.435.01.36-.303-.074-.313.132-.395.348-.626.211-.229.497-.693.53-1.096.034-.402.506-.208.896-.082.39.127.735-.36.487-.591-.209-.191-.11-.204.3-.383.41-.179.247-.638-.081-.87-.231-.16-.378-.608-.445-.871A7.17 7.17 0 018 .842v.003zM8 0C3.588 0 0 3.588 0 8s3.588 8 8 8 8-3.588 8-8-3.588-8-8-8z","fill":"#4D4D4D"}})])
          )
        }
      }
    